export default ({ $api, store }) => {
  $api.register('geo', '/web/public/address', request => ({
    async regions(params) {
      const response = await request('GET', '/region', { params });
      if (response.success) {
        response.data = response.data.map(({ id, title }) => ({
          id,
          label: title,
          value: title,
          cities: [],
        }));
      }
      return response;
    },
    async cities(regionId) {
      const response = await request('GET', `/region/${regionId}/city`);
      if (response.success) {
        response.data = response.data.map(({ title }) => title);
      }
      return response;
    },

    async districts(params) {
      const response = await request('GET', `/district`, { params });
      if (response.success) {
        response.data = response.data.map(({ title }) => title);
      }
      return response;
    },

    async wards(params) {
      const response = await request('GET', `/ward`, { params });
      if (response.success) {
        response.data = response.data.map(({ title }) => title);
      }
      return response;
    },

    async getCities(params) {
      const response = await request('GET', `/city`, { params });
      if (response.success) {
        response.data = response.data.map(city => ({
          ...city,
          label: city.title,
          value: city.title,
        }));
      }
      return response;
    },
  }));

  store.registerModule(
    'geo',
    {
      namespaced: true,
      state: () => ({
        regions: [],
        districts: [],
        cities: [],
        wards: [],
      }),
      getters: {
        /**
         * Get region object from name
         * @param {Object} state
         * @returns {Function}
         */
        getRegionByName({ regions }) {
          /**
           * @param {String} regionName
           * @returns {Object | undefined}
           */
          return regionName => regions.find(({ label }) => label === regionName);
        },
        /**
         * Get cities by region name
         * @param {Object} state
         * @param {Object} getters
         * @returns {Function}
         */
        getCitiesByRegion(state, { getRegionByName }) {
          /**
           * @param {String} regionName
           * @returns {Array}
           */
          return regionName => {
            const region = getRegionByName(regionName);
            return region ? region.cities : [];
          };
        },
      },
      mutations: {
        /**
         * Set state property if it exists
         * @param {Object} state
         * @param {Object} payload
         */
        SET(state, { key, value }) {
          if (key in state) state[key] = value;
        },
        /**
         * Add cities to region
         * @param {Object} state
         * @param {Object} payload
         */
        addCities(state, { region, data }) {
          if (region) region.cities = data;
        },
      },
      actions: {
        // Load all regions
        async getRegions({ state, commit }, params) {
          if (!state.regions.length) {
            const { success, data } = await $api.dispatch('geo/regions', params);
            if (success) commit('SET', { key: 'regions', value: data });
          }
        },
        // Load cities by region name
        async getCities({ commit, getters }, regionName) {
          const region = getters.getRegionByName(regionName);

          if (region && !region.cities.length) {
            const { success, data } = await $api.dispatch('geo/cities', region.id);
            if (success) commit('addCities', { region, data });
          }
        },

        async getDistricts({ commit }, params) {
          const { success, data } = await $api.dispatch('geo/districts', params);
          if (success) commit('SET', { key: 'districts', value: data });
        },

        async getWards({ commit }, params) {
          const { success, data } = await $api.dispatch('geo/districts', params);
          if (success) commit('SET', { key: 'wards', value: data });
        },

        async searchCities({ commit }, params) {
          const { success, data } = await $api.dispatch('geo/getCities', params);
          if (success) commit('SET', { key: 'cities', value: data });
        },
      },
    },
    {
      preserveState: process.browser && !process.env.SPA,
    }
  );
};
